import { createHashRouter, RouterProvider } from "react-router-dom";
import Home from "./views/home.js";
import Party from "./views/party/index.js";
import CreateParty from "./views/createParty.js";
import Debug from "./debug/index.js";
import Admin from "./views/admin.js";

const router = createHashRouter([
	{ path: "/", element: <Home /> },
	{ path: "p", element: <CreateParty /> },
	{ path: "p/:partyId", element: <Party /> },
	{ path: "debug", element: <Debug /> },
	{ path: "admin", element: <Admin /> },
]);

function MainRouter() {
	return <RouterProvider router={router} />;
}

export default MainRouter;
